<script lang="ts">
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";

	const { GTM, COOKIES } = getGlobalSettings();

	/* eslint-disable */
</script>

<svelte:head>
	<link rel="preconnect" href="https://cdn.cookie-script.com" />

	<script>
		window.dataLayer = window.dataLayer || [];
		if (typeof gtag !== "function") {
			function gtag() {
				dataLayer.push(arguments);
			}
		}
		gtag("consent", "default", {
			ad_storage: "denied",
			analytics_storage: "denied",
			personalization_storage: "denied",
			ad_user_data: "denied",
			ad_personalization: "denied",
			functionality_storage: "granted",
			security_storage: "granted",
			wait_for_update: 500,
		});
		dataLayer.push({
			consent: {
				default: {
					ad_storage: "denied",
					analytics_storage: "denied",
					personalization_storage: "denied",
					ad_user_data: "denied",
					ad_personalization: "denied",
					functionality_storage: "granted",
					security_storage: "granted",
					wait_for_update: 500,
				},
			},
		});
	</script>

	{@html `<script async type="text/javascript" charset="UTF-8" src="//cdn.cookie-script.com/s/${COOKIES}.js"></script>`}
	{@html `<script>
		window.addEventListener("load", function () {
			(function (w, d, s, l, i) {
				w[l] = w[l] || [];
				w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
				var f = d.getElementsByTagName(s)[0],
					j = d.createElement(s),
					dl = l != "dataLayer" ? "&l=" + l : "";
				j.async = true;
				j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
				f.parentNode.insertBefore(j, f);
			})(window, document, "script", "dataLayer", "${GTM}");
		});
	</script>`}
</svelte:head>

<noscript>
	<!-- svelte-ignore a11y_missing_attribute -->
	<iframe
		src="https://www.googletagmanager.com/ns.html?id={GTM}"
		height="0"
		width="0"
		style="display:none;visibility:hidden"
	></iframe>
</noscript>
